// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideSun as RawLucideSun } from "lucide-react";
export const LucideSun = /* @__PURE__ */ createIcon(RawLucideSun, "LucideSun", 2);
